import SidebarTopContent from './SidebarTopContent.js';

export default SidebarTopContent;
